// const isFacebookApp = () => {
//   let ua = navigator.userAgent || navigator.vendor || window.opera;
//   return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
// }

export default {
  showDesktopVersion () {
    // Note - instead of using isFacebookApp having a timer to check
    // if window inner width has changed
    // Facebook Mobile browser has issue where it gives wrong resolution
    // And even when resolution changes it does not trigger resize
    // if (isFacebookApp() && this.windowWidth < 1200) {
    //   return false
    // }
    return this.windowWidth >= 960
    // return this.$vuetify.breakpoint.mdAndUp && this.windowWidth >= 960
  }
}
